import { OFFLINE_MODE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function GetOfflineModeByCode(code){
    const api = `${OFFLINE_MODE_API}${code}/`;
    return axiosHttp.get(api);
}